import { hasURLIncludeSubdomain, isValidHttpUrl, removeURLProtocolAndSubdomains } from "src/helpers/url";


export const formattedUserSiteURL = (linkSite: string) => isValidHttpUrl(linkSite) || hasURLIncludeSubdomain(linkSite) ?
  removeURLProtocolAndSubdomains(linkSite) : linkSite;
